module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-ap-084576da.png";